import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgArrowClockwiseClockIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M51.2 32c0-10.604-8.596-19.2-19.2-19.2V9.6c12.372 0 22.4 10.029 22.4 22.4S44.372 54.4 32 54.4C19.63 54.4 9.6 44.371 9.6 32a22.34 22.34 0 0 1 6.724-16H6.4v-3.2h10.538a3.2 3.2 0 0 1 2.262.937L21.463 16c.6.6.937 1.414.937 2.263V28.8h-3.2V18.263l-.3-.3A19.14 19.14 0 0 0 12.8 32c0 10.604 8.596 19.2 19.2 19.2S51.2 42.604 51.2 32m-20.8-.58V22.4h3.2v9.02l7.63 9.156-2.459 2.048-7.629-9.155a3.2 3.2 0 0 1-.742-2.048"
    />
  </svg>
)
export default SvgArrowClockwiseClockIcon
